import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {analyticsClient} from '../../analytics-client';

import {useUpdateUserSetting} from '../core/use-update-user-setting';

import {resyncAiAgentSidebarClasses} from './helpers';

export function useTeamAiSidebarToggle() {
    const updateSetting = useUpdateUserSetting();

    const setSidebarCollapsed = (userId: string, shouldCollapse: boolean) => {
        const value = shouldCollapse ? '1' : '0';

        updateSetting({
            userId,
            settingName: Nut_Settings_User.SETTING_AI_AGENT_SIDEBAR_OPEN,
            value,
            propertyOnUser: 'isAiAgentSidebarOpen',
        });

        if (shouldCollapse) {
            analyticsClient.track(analyticsClient.EVENTS.TRACK_AI_ASSISTANT_SIDEBAR_OPENED);
        }

        resyncAiAgentSidebarClasses(shouldCollapse);
    };

    return setSidebarCollapsed;
}
